import { ModelScopeSettingsItemRespone, ModelScopesResponse } from "@api/apiClient";
import { toJS } from "mobx";

// Add to the global window object for auto-completion in the console
// > window.ScopesStore
export { };
declare global {
  interface Window {
    ScopesStore: ScopesStore;
  }
}

// TODO: rename ModelScopeStore
class ScopesStore {
  public isScopesEnabled = false;
  public scopes: ModelScopeSettingsItemRespone[] = [];
  public selectedScopeIds: number[] = [];
  public modelScopes: Record<string, ModelScopesResponse> = {};

  constructor() {
    window.ScopesStore = this;
    //makeAutoObservable(this, {}, { autoBind: true });
  }

  get dump() {
    return toJS(this);
  }

  setDefaults = () => {
    this.setIsScopesEnabled(localStorage.getItem("isScopesEnabled") !== "false");
  };

  setIsScopesEnabled = (isScopesEnabled: boolean) => {
    console.log("setIsScopesEnabled", isScopesEnabled);
    this.isScopesEnabled = isScopesEnabled;
    localStorage.setItem("isScopesEnabled", this.isScopesEnabled.toString());
  };

  toggleIsScopesEnabled = () => {
    console.log("toggleIsScopesEnabled");
    this.isScopesEnabled = !this.isScopesEnabled;
    localStorage.setItem("isScopesEnabled", this.isScopesEnabled.toString());
  };

  setScopes(scopes: ModelScopeSettingsItemRespone[]) {
    console.log("setScopes", scopes);
    this.scopes = scopes || [];
  }

  setSelectedScopeIds(selectedScopeIds: number[]) {
    console.log("setSelectedScopes", selectedScopeIds);
    this.selectedScopeIds = selectedScopeIds || [];
  }

  setModelScope(modelId: string, modelScopes: ModelScopesResponse) {
    this.modelScopes[modelId] = modelScopes;
  }
}

export default ScopesStore;
